
const filterCountries = () => {

  const input = document.getElementById('search-country').value.toLowerCase().trim();
  const listItems = document.querySelectorAll('#country-list li');

  listItems.forEach((item) => {
    const { countryName, countryIso, countrySymbol } = item.querySelector('a').dataset;

    const matchesInput = [countryName, countryIso, countrySymbol]
      .map((value) => value.toLowerCase())
      .some((value) => value.includes(input));

    item.style.display = matchesInput || input === '' ? '' : 'none';
  });

};

document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.product__text-content + button');

  if (buttons.length > 0) {
    const regex = /^shopify-section-template--.+_product_details_.+$/;
    const elements = Array.from(document.querySelectorAll('[id]'));
    const matchingElement = elements.find(el => regex.test(el.id));
    if (matchingElement) {
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const targetElement = document.getElementById(matchingElement.id);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      });
    } else {
      buttons.forEach((button) => {
        button.style.display = 'none';
      });
    }
  }

});

document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('a[href="#swatch-drawer"]');

  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault(); 
        const swatchDrawer = document.querySelector('swatch-drawer');
        if (swatchDrawer) {
          swatchDrawer.show();
        }
      });
    });
  }
  
});

document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('a[href="#smile"]');

  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault(); 
        SmileUI.openPanel()
      });
    });
  }
  
});

document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.chat-button');

  if (buttons.length > 0) {

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {

        event.preventDefault(); 
        document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-toggle").click();
        
      });
    });

  }

});


// FIX LAYOUT ISSUES ON MOBILE DEVICES FOR SMILE.IO

(function () {
  function moveSmileToBody() {
    var el = document.getElementById('smile-ui-container');
    if (el && el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  }

  // Run now + on section loads
  moveSmileToBody();
  window.addEventListener('load', moveSmileToBody);
  document.addEventListener('shopify:section:load', moveSmileToBody);
  document.addEventListener('shopify:section:unload', moveSmileToBody);

  // Watch for late/dynamic injection
  var obs = new MutationObserver(function(muts){
    for (var m of muts) {
      for (var n of m.addedNodes) {
        if (n.nodeType === 1 && (
             n.id === 'smile-ui-container' ||
            (n.querySelector && n.querySelector('#smile-ui-container'))
        )) {
          moveSmileToBody();
        }
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();